import { z } from 'zod';

// The "Case reference number" of a generated document must be present as
// either a GIP code (L&G) or a policy number (Aviva, which has no GIP code) —
// which one an organization uses is its careDocuments.caseReferenceSource
// setting, so the document only requires that ONE of them is there.
export const requiresCaseReferenceNumber = (ctx: z.core.ParsePayload<any>) => {
  const document = ctx.value;

  if (document?.gip?.code || document?.policyNumber) {
    return;
  }

  ctx.issues.push({
    code: 'custom',
    input: document,
    path: ['policyNumber'],
    message: 'Case reference number is required',
  });
};
